<ng-container *ngIf="formPlycaGroup">
  <ng-container *ngIf="editable; else nonEditable">
    <div class="p-inputgroup" [formGroup]="formPlycaGroup">
      <!-- [ngClass]="(editable) ? undefined : 'mr-0 ml-0'" -->
      <input id="sender" type="text" [ngModel]="getAgentDescription(model.dto.sender)" pInputText
        class="plForm-element EDITABLE" [attr.disabled]="'disabled'" formControlName="sender" />
      <button class="btn btn-outline-secondary EDITABLE integrado" aria-expanded="false" appNoDblClick
        pTooltip="{{ 'General.delete' | translate}}" tooltipPosition="top" (click)="deleteFrom()">
        <i class="pi pi-times" aria-hidden="true" tabindex="-1"></i>
      </button>
      <button class="btn btn-outline-secondary EDITABLE integrado" aria-expanded="false" appNoDblClick
        pTooltip="{{ 'General.search.text' | translate}}" tooltipPosition="top" (click)="searchFrom()">
        <i class="pi pi-caret-down" aria-hidden="true"></i>
      </button>
    </div>
  </ng-container>
</ng-container>
<ng-template #nonEditable>
  <div [formGroup]="formPlycaGroup">
    <input id="sender" type="text" [ngModel]="getAgentDescription(model.dto.sender)" pInputText
      class="plForm-element NOEDITABLE" [attr.disabled]="'disabled'" formControlName="sender" />
  </div>
</ng-template>